import { Typography, Button } from "@mui/material";

const Info = ({ close, register }) => {
  return (
    <div
      style={{
        height: "100vh",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 20
      }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography variant="h5" align="center">
            What is the Skill Swap?
          </Typography>
          <Typography>
            {" "}
            Welcome to Skill Swap—an alternative marketplace for trading skills
            in today's economy! Don't let inflation and tarrifs hold you back
            from getting the help you need.
          </Typography>
          <Typography>
            Here’s the deal: Create your own Skill Swap profile, listing the
            services you can provide and what you'd love in return. Our smart
            matching system pairs you with members who perfectly complement your
            needs, making it easy to exchange services without spending a cent.
          </Typography>
          <Typography>
            Need electronics repaired and can offer accounting help? Or maybe
            you're a tech wizard looking for tax advice? Skill Swap is all about
            trading your time, saving your cash, and connecting with your
            community.
          </Typography>
          <Typography>
            Ready to dive in? Click the register button below! Once this dialog
            closes, you'll see your new Skill Swap profile waiting for you in
            Event Profiles. Just fill out the quick questions, and we'll start
            matching you with your perfect skill-trading partners!
          </Typography>
          <Typography >
            If that sounds good to you, click the register button below. Once
            this dialog closes, you will see a new Skill Swap profile in your
            Event Profiles. Open that, fill out the questions, and then we
            will start connecting you with your matches.
          </Typography>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          flexDirection: "column",
          marginBottom: 20
        }}
      >
        <Button variant="contained" onClick={register}>
          Sign me Up!
        </Button>
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default Info;
